// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Tmsm","inner":"Form_inner__3raw4","range":"Form_range__3quIk","name":"Form_name__cv57j","actions":"Form_actions__2kztV"};